import React, { FunctionComponent } from "react";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import { getInitials } from "../../utils/text";

export const UserChip: FunctionComponent<{ name: string }> = (props): JSX.Element => {
    return (
        <Chip sx={{ backgroundColor: "#1BA0E9" }} color="primary" variant="filled" avatar={<Avatar>{ getInitials(props.name)}</Avatar>} label={props.name} />
    )
}